export default __webpack_public_path__ + "static/media/largeRight.23ab4558.svg";